import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndpoint'; // same path style
import { SuperloginService } from '../superlogin/superlogin.service';

@Injectable({
  providedIn: 'root'
})
export class AddfeesitemsService {

  constructor(
    private http: HttpClient,
    private urls: UrlSignature,
    private authService: SuperloginService
  ) {}

  // ✅ SAME pattern as ApplicationfeesdashboardService
  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken() || '';
    return new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });
  }

  // ✅ POST: Add Fee Item
  addFeeItem(payload: any): Observable<any> {
    return this.http.post<any>(
      this.urls.AddfeeItemsUrl,
      payload,
      { headers: this.getHeaders() }
    );
  }
}